import * as types from './actionTypes';
export function fundsSet(funds: any) {
  return { type: types.FUNDS_SET, funds };
}